
export const MAIN_API_URL = process.env.REACT_APP_ENVIRONMENT === 'production' ? 'https://api.creativeocto.io' : 'http://localhost:5080';
export const FRONTEND_URL = 'http://localhost:3000';
export const API_URL = process.env.REACT_APP_ENVIRONMENT === 'production' ? 'https://api.creativeocto.io/api/client' : 'http://192.168.2.78:5080/api/client';
export const BACKEND_URL = process.env.REACT_APP_ENVIRONMENT === 'production' ? 'https://api.creativeocto.io/' : 'http://192.168.2.78:5080/';

// export const API_URL = 'https://api.creativeocto.io/api/client'